import React from 'react';
import logo from '../ATSAP_orange_v2.png';
import data from '../questions/questions.json';

class LeadForm extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        question: 1
      }
    }
    
    componentWillMount() {

    }

    // Method called when answer is given
    buttonClicked(answerNumber) {
        var nextQuestion = data["Question " + this.state.question]["answer_"+answerNumber+"_next_question"]
        this.setState({question:nextQuestion});
    }
  
    render() {
        if(data["Question " + this.state.question]["questionType"] === "question"){
            return(
                <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <p>
                    {data["Question " + this.state.question]["question"]}
                    </p>
                    <div>
                    <button className="button" onClick={() => {this.buttonClicked(1)}}>{data["Question " + this.state.question]["answer 1"]}</button>
                    <p> </p>
                    <button className="button" onClick={() => {this.buttonClicked(2)}}>{data["Question " + this.state.question]["answer 2"]}</button>
                    <p> </p>
                    <button className="button" onClick={() => {this.buttonClicked(3)}}>{data["Question " + this.state.question]["answer 3"]}</button>
                    </div>
                </header>
                </div>
            );
        }
        else if(data["Question " + this.state.question]["questionType"] === "answer"){
            return(
                <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <p>
                    {data["Question " + this.state.question]["question"]}
                    </p>
                    <div>
                    <a className="button" href={data["Question " + this.state.question]["answer_1_next_question"]} >{data["Question " + this.state.question]["answer 1"]}</a>
                    <p> </p>
                    <a className="button" href={data["Question " + this.state.question]["answer_2_next_question"]} >{data["Question " + this.state.question]["answer 2"]}</a>
                    <p> </p>
                    <a className="button" href={data["Question " + this.state.question]["answer_3_next_question"]} >{data["Question " + this.state.question]["answer 3"]}</a>
                    </div>
                </header>
                </div>
            );
        }
    }
  }
  
  export default LeadForm;
  